<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="FRACIONAMENTO" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/pattern.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/fracionamentos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button rendoly (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4"
            [disabled]="this.entidade.id">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-2" />
      <div class="form-row">
        <div class="col-sm-6">
          <p-fieldset legend="Produto a ser fracionado">
            <div class="form-row mt-2" formGroupName="fracionar">
              <div class="col-sm-9 form-group">
                <label for="fracionar_prod">Produto</label>
                <p-autoComplete id="fracionado_prod" formControlName="produto" [forceSelection]="true"
                  [autoHighlight]="true" [field]="fracionarAutoComplete.conversor"
                  (onSelect)="carregarUnidades($event, 'F1')" [suggestions]="fracionarAutoComplete.lista"
                  (completeMethod)="fracionarAutoComplete.filtrar($event)" [style]="{ width: '100%' }"
                  inputStyleClass="form-control" minLength="2">
                  <ng-template let-produto pTemplate="item">
                    {{produto.codigo}} {{produto.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionar_un">UN.</label>
                <select [compareWith]="compareFn" id="fracionar_un" formControlName="unidade" class="form-control"
                  style="width: 100%;" (change)="changeUnidade('F1')">
                  <option [ngValue]="item.unidade" *ngFor="let item of listProdUnFracionar">
                    {{item.unidade.nome}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-9 form-group">
                <label for="fracionar_qtde">Lote/Vencimento.</label>
                <p-autoComplete styleClass="form-control form-control-sm p-0" [forceSelection]="true"
                [autoHighlight]="true" [inputStyle]="{'font-size' : '12px'}" 
                (onSelect)="onChangeLote($event)" [suggestions]="listLoteVecFiltro" [style]="{ width: '100%' }"
                (completeMethod)="buscarLoteVencimento($event)" [field]="conversorLote" [dropdown]="true">
                <ng-template let-itemL pTemplate="item">
                  <div class="d-flex jutify-content-between align-items-center" style="font-size: 12px;">
                    <div class="d-flex flex-column justify-content-center align-items-start">
                      <span><b>LOTE:</b> {{itemL.lote}}</span>
                      <span><b>VENCIMENTO:</b> {{itemL.vencimento | date : 'dd/MM/yyyy' : 'GMT'}}</span>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-start ml-2">
                      <span><b>SALDO:</b></span>
                      <span>{{itemL.saldo_atual | number:'1.5-5'}}</span>
                    </div>
                  </div>
                </ng-template>
              </p-autoComplete>
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionar_qtde">Qtde.</label>
                <input id="fracionar_qtde" [imask]="imaskQtd" unmask="typed" class="form-control" type="text"
                  formControlName="qtd_fracionar">
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="col-sm-6">
          <p-fieldset legend="Produto fracionado">
            <div class="form-row mt-2" formGroupName="fracionado">
              <div class="col-sm-9 form-group">
                <label for="fracionado_prod">Produto</label>
                <p-autoComplete id="fracionado_prod" formControlName="produto" [forceSelection]="true"
                  [autoHighlight]="true" [field]="fracionadoAutoComplete.conversor"
                  (onSelect)="carregarUnidades($event, 'F2')" [suggestions]="fracionadoAutoComplete.lista"
                  (completeMethod)="fracionadoAutoComplete.filtrar($event)" [style]="{ width: '100%' }"
                  inputStyleClass="form-control" minLength="2">
                  <ng-template let-produto pTemplate="item">
                    {{produto.codigo}} {{produto.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionado_un">UN.</label>
                <select [compareWith]="compareFn" id="fracionado_un" formControlName="unidade" class="form-control"
                  style="width: 100%;" (change)="changeUnidade('F2')">
                  <option [ngValue]="item.unidade" *ngFor="let item of listProdUnFracionado">
                    {{item.unidade.nome}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-9 form-group">
                <label for="favorecido">Fornecedor</label>
                <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                  [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                  inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }" [forceSelection]="true"
                  [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                  <ng-template let-favorecido pTemplate="item">
                    {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionado_qtde">Qtde.</label>
                <input id="fracionado_qtde" [imask]="imaskQtd" unmask="typed" class="form-control" type="text"
                  formControlName="qtd_fracionado">
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="form-row">
        <div class="col-sm-12 form-group">
          <label for="observacao">Observação</label>
          <textarea name="obs" id="observacao" rows="3" class="form-control" formControlName="observacao">
          </textarea>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>